import React, { useEffect, useState } from "react";
import { Form, Table, Image } from "react-bootstrap";

import { FormControl, Select, InputLabel, Menu, MenuItem } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { HomeReusableButton } from "../../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableButton";
import HomeReusableTopBarNavigation from "../../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
// import Media from "react-media";
// import Pagination from "rc-pagination";
import { RightSideCountTop } from "../../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { ExperienceSummaryReport } from "../../../../store/actions/SuperAdminReports/SuperAdminReports";
import isEmpty from "../../../../store/validation/is-Empty";
import { SmallLoader } from "../../../Loader/SmallLoader";
import TodayDateTime from "../../../reusableComponents/AllDateComponents/TodayDateTime";
// import {
//   ORDER_STATUS,
//   ORDER_TYPE,
//   PAYMENT_STATUS,
//   PAYMENT_TYPE,
// } from "../../../../enums/OrderEnums";
import moment from "moment";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import BasicPagination from "../../../Pagination/Pagination";
import SelectFilter from "../../../reusableComponents/selectFilter";
// import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import { FilterMain } from "../../../superAdminComponents/superAdminAllComponent/superAdminRefferalsCode/InsidePages/ReferralUserComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Col, Row } from "react-bootstrap";
import { getSubCateogryWithCategoryId } from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";

// import hi from '../../../../components/'
function ExpSummaryReport(props) {
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [dateQuery, setDateQuery] = useState({
    // startDate: moment().format("YYYY-MM-DD"),
    // endDate: moment().format("YYYY-MM-DD"),
  });
  const [state, setState] = useState({
    search: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [restaurantReverse, setRestaurantReverse] = useState("");
  const [diffDays, setDiffDays] = useState("Today");

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    setDiffDays(type);
  };

  const onSearchChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const [showSearch, setShowSearch] = useState(false);

  const getData = () => {
    // props.All_Order_Reports(props.auth.user.accessToken,dateQuery);
    props.ExperienceSummaryReport(props.auth.user.accessToken, dateQuery);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => (e) => {
    setRestaurantReverse(value);
    handleClose();
  };

  useEffect(
    (async) => {
      const DateForm = {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      };
      if (!isEmpty(dateQuery)) {
        getData(
          props.auth.user.accessToken,
          dateQuery.startDate === "undefined" ? DateForm : dateQuery
        );
      }

      // getData(props.auth.user.accessToken);
    },
    [dateQuery]
  );

  const [filter, setFilter] = useState(false);
  const [filterData, setFilterData] = useState("");

  const [filterData_final, setFilterData_final] = useState("");

  const [categoryList, setCats] = useState([]);

  const onSuccessGetSubCategory = (data) => {
    var subC = [];

    for (var i = 0; i < data.length; i++) {
      if (data[i].status === "APPROVED") subC.push(data[i].title);
    }
    // setLoading(false);
    setCats(subC);
  };
  // useEffect(() => {
  //   props.getSubCateogryWithCategoryId(
  //     onSuccessGetSubCategory,
  //     "5f562c9094ac7fdf47ea1d0a"
  //   );
  // }, []);

  let tempdata = [];
  if (restaurantReverse === "A-Z") {
    tempdata =
      props?.expReport &&
      props?.expReport?.restaurantExpReport.sort((a, b) => {
        if (a.restaurant_name !== null && b.restaurant_name !== null) {
          if (a.restaurant_name < b.restaurant_name) return -1;
          if (a.restaurant_name > b.restaurant_name) return 1;
          return 0;
        }
      });
  } else if (restaurantReverse === "Z-A") {
    tempdata =
      props?.expReport &&
      props?.expReport?.restaurantExpReport.sort((a, b) => {
        if (a.restaurant_name !== null && b.restaurant_name !== null) {
          if (a.restaurant_name < b.restaurant_name) return 1;
          if (a.restaurant_name > b.restaurant_name) return -1;
          return 0;
        }
      });
  }

  tempdata =
    props?.expReport &&
    props?.expReport?.restaurantExpReport
      ?.filter((data) => {
        return data?.restaurant_name
          .toLowerCase()
          .includes(state.search.toLowerCase());
      })
      .filter((item) => {
        return item?.primary_restaurant_type
          ?.toLowerCase()
          ?.includes(filterData_final?.toLowerCase());
      });
  // const downloadData = {
  //   headers: [
  //     { label: "BusinessName", key: "name" },
  //     { label: "Area", key: "area" },
  //     { label: "ID", key: "id" },
  //     { label: "No. Of Events \n & Amount", key: "totalEventAmount" },
  //     { label: "Ticket Booked \n Events & Amount", key: "tbEventAmount" },
  //     { label: "RSVP & Scan And Pay Amount", key: "rsvpEventAmount" },
  //     { label: "Online Events", key: "onlineOffer" },
  //     { label: "Offline Events", key: "offlineOffer" },
  //     { label: "Type Of Establishment", key: "primary_restaurant_type" },
  //     { label: "Period", key: "period" },
  //   ],
  //   data: tempdata
  //     ? tempdata?.map((ele) => {
  //         return {
  //           name: ele?.restaurant_name,
  //           area: ele?.area,
  //           id: ele?._id,
  //           totalEventAmount: `${ele?.noOfEvent} \n ${ele?.totalEventAmount}`,
  //           tbEventAmount: ` ${ele?.tbEvent} \n ${ele?.tbEventAmount}`,
  //           rsvpEventAmount: `${ele?.rsvpEvent} \n ${ele?.rsvpEventAmount}`,
  //           onlineOffer: ele?.onlineEvent,
  //           offlineOffer: ele?.offlineEvent,
  //           primary_restaurant_type: ele?.primary_restaurant_type,
  //           period: `${moment(dateQuery.startDate).format(
  //             "MM/DD/YYYY"
  //           )} -${moment(dateQuery.endDate).format("MM/DD/YYYY")}`,
  //         };
  //       })  
  //     : [],
  // };

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          {/* <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div> */}
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="super admin home" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Experience Summary Report
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400 my-2"
                  >
                    Report Run Date: {moment().format("Do MMM, YYYY")}
                  </div>
                  <div className="d-flex">
                    <div className="f12-400" style={{ color: "#9E9E9E" }}>Report Range Date :</div>
                    <div className="f12-500 ml-2">
                      {" "}
                      {moment(dateQuery?.startDate).format("ll")} -{" "}
                      {moment(dateQuery?.endDate).format("ll")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="d-flex align-items-center justify-content-between">
                    <Image
                      onClick={() =>
                        // this.setState({ showSearch: !this.state.showSearch })
                        setShowSearch(!showSearch)
                      }
                      alt="Search"
                      title="Search"
                      width="80px"
                      src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                    />
                    <Image
                      // onClick={handleClick}
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {/* {userFilter.map((ele, index) => {
                        return (
                          <MenuItem
                            value={ele.title}
                            key={index}
                            onClick={() => setSort(ele.title)}
                            disabled={ele.disabled}
                          >
                            {ele.title}
                          </MenuItem>
                        );
                      })} */}
                    </Menu>
                    <Image
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                      alt="Filter Icon"
                      onClick={() => {
                        // setshowFilter(!showFilter);
                      }}
                    />
                    {/* <CSVDownloader
                        filename={"settlement"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      /> */}
                  </div>
                </div>
                <div>
                  <SelectFilter onDateChange={onDateChangeHandler()} />
                </div>
                {/* <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                      <SortComponent
                        handleClick={handleClick}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        selectClick={(data) => handleSelect(data)}
                      />
                    </div>
                    <div
                      className="f10-400"
                      align="center"
                      onClick={() => setFilter(!filter)}
                    >
                      <img
                        src={require("../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      
                    </div>
                  </div>
                </div> */}
              </div>
              <FilterMain
                filterOptions={
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-Status">
                            Type Of Establishment
                          </InputLabel>
                          <Select
                            value={filterData}
                            onChange={(e) => setFilterData(e.target.value)}
                            //
                            label="Type Of Establishment"
                            inputProps={{
                              name: "Type Of Establishment",
                              id: "outlined-Status",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {categoryList.map((data, index) => {
                              return (
                                <MenuItem value={data} key={index}>
                                  {data}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                  </Row>
                }
                show={filter}
                onCancel={() => setFilter(false)}
                onFilter={() => setFilterData_final(filterData)}
              />
              {showSearch && (
                <>
                  <div className="filter-button-search">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search"
                        name="search"
                        inputProps={{
                          "aria-label": "Search by Name or Phone Number",
                        }}
                        onChange={onSearchChange}
                        value={state.search}
                      />
                    </Paper>
                  </div>
                </>
              )
              }
              <hr />
              <div className="d-flex justify-content-end align-items-center pt-4 pb-3">
                <RightSideCountTop
                  content={[
                    {
                      name: "Inactive Experience",
                      value: props?.expReport?.totalInactive || 0,
                      backgroundColor: "#FFEDE9",
                      color: "#EE3A23",
                    },
                    {
                      name: "Active Experience",
                      value: props?.expReport?.totalActive || 0,
                      backgroundColor: "#EFEBFB",
                      color: "#6F32C9",
                    },
                    {
                      name: "Events/Amount",
                      value: `${props?.expReport?.totalCuratedExp || 0}/₹ ${props?.expReport?.totalCuratedAmount || 0}`,
                      backgroundColor: "#D8F3F4",
                      color: "#138B90",
                    },
                    {
                      name: "Occasions/Amount",
                      value: `${props?.expReport?.totalSpecialExp || 0}/₹ ${props?.expReport?.totalSpecialAmount || 0}`,
                      backgroundColor: "#D8F3F4",
                      color: "#138B90",
                    },
                    {
                      name: "Total Experience/Amount",
                      value: `${props?.expReport?.totalExps || 0}/₹ ${props?.expReport?.totalAmount || 0}`,
                      backgroundColor: "#D8F3F4",
                      color: "#138B90",
                    }
                  ]}
                />
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead style={{ fontSize: "10px" }}>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "240px" }} className="f12-700">
                          Business Name
                          <br /> /Location/ID
                        </th>
                        <th style={{ width: "160px" }} className="f12-700">
                          Total No.<br /> of Experience
                          <br /> & Amount
                        </th>
                        <th style={{ width: "160px" }} className="f12-700">
                          Curated Experience
                          <br /> & Amount
                        </th>
                        <th style={{ width: "160px" }} className="f12-700">
                          Special Experience
                          <br /> & Amount
                        </th>
                        <th style={{ width: "160px" }} className="f12-700">
                          Active
                          <br /> Experience
                        </th>
                        <th style={{ width: "160px" }} className="f12-700">
                          Inactive
                          <br /> Experience
                        </th>
                        <th style={{ width: "160px" }} className="f12-700">
                          Type of
                          <br /> Establishment
                        </th>
                        <th style={{ width: "160px" }} className="f12-700">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {props.auth.secondary_loader ? (
                      <SmallLoader />
                    ) : (
                      !isEmpty(tempdata) &&
                      tempdata &&
                      tempdata.slice(start, end).map((data, index) => {
                        // console.log(data);
                        // const date1 = moment(data?.createdAt).format("MM/DD/YYY");
                        // const date2 = moment().format("MM/DD/YYY");
                        // let createDate = new Date(date1);
                        // let todayDate = new Date(date2);
                        // // console.log(createDate,todayDate)
                        // const diffTime = Math.abs(todayDate - createDate);
                        // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                        return (
                          <tbody>
                            <tr className="super_admin_all_users_table_body">
                              <td
                                style={{ width: "240px" }}
                                className="f12-500"
                              >
                                <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                                  <div className="super-admin-suggestion-imageBoxOne enIMG33">
                                    <img
                                      src={data?.logo_url}
                                      alt="Icon"
                                      className="img-fluid rounded-circle"
                                    />
                                  </div>

                                  <div className="pl-3">
                                    <div className="f10-500">
                                      {data?.restaurant_name}
                                    </div>
                                    <div className="f9-400">{data?.area}</div>
                                    <div className="f9-400">{data?._id}</div>
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{ width: "160px" }}
                                className="f12-500"
                              >
                                {data?.noOfExp}
                                <br />₹ {data?.totalExpAmount}
                              </td>
                              <td
                                style={{ width: "160px" }}
                                className="f12-500"
                              >
                                {data?.curatedExp}
                                <br />₹ {data?.curatedExpAmount}
                              </td>
                              <td
                                style={{ width: "160px" }}
                                className="f12-500"
                              >
                                {data?.specialExp}
                                <br />₹ {data?.specialExpAmount}
                              </td>
                              <td
                                style={{ width: "160px" }}
                                className="f12-500"
                              >
                                {data?.activeExp}
                              </td>
                              <td
                                style={{ width: "160px" }}
                                className="f12-500"
                              >
                                {data?.inactiveExp}
                              </td>
                              <td
                                style={{ width: "160px" }}
                                className="f12-500"
                              >
                                {data?.primary_restaurant_type}
                              </td>
                              <td
                                style={{ width: "160px" }}
                                className="f12-500"
                              >
                                <NavLink
                                  variant="link"
                                  className="enIconBtn mr-3"
                                  to={{
                                    pathname: `/superadmin/experiencesummaryreports/${data?.vendor_id?._id}`,
                                    state: { data: data },
                                  }}
                                >
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/eye.svg")}
                                    alt="View"
                                    title="View"
                                    fluid
                                  />
                                </NavLink>
                              </td>
                            </tr>
                          </tbody>
                        );
                      })
                    )}
                  </Table>
                </div>
              </div>

              <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={
                    props?.expReport?.restaurantExpReport?.length
                  }
                  limit={5}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
          {/* <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media> */}
        </div>
      </div>
    </React.Fragment>
  );
}

ExpSummaryReport.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  expReport: PropTypes.array.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  expReport: state.reports.admin_exp_summary,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  getSubCateogryWithCategoryId,
  ExperienceSummaryReport,
})(ExpSummaryReport);

// export default ExpSummaryReport;
